import { PlaylistItemDTO } from "../../lib/types";
import { DSPlayerAudio } from "./DSPlayerAudio";
import { DSPlayerDoc } from "./DSPlayerDoc";
import { DSPlayerDynamicFromTemplate } from "./DSPlayerDynamicFromTemplate";
import { DSPlayerImage } from "./DSPlayerImage";
import { DSPlayerLink } from "./DSPlayerLink";
import { DSPlayerSplit } from "./DSPlayerSplit";
import { DSPlayerVideo } from "./DSPlayerVideo";

type Props = {
  item: PlaylistItemDTO;
  isFullScreen?: boolean;
  onVideoEnded: () => void;
  onAudioEnded: () => void;
};

export const DsPlayerItemRenderer: React.FC<Props> = ({ item, isFullScreen, onVideoEnded, onAudioEnded }) => {
  return (
    <>
      {item.type === "Video" && <DSPlayerVideo item={item} onVideoEnded={onVideoEnded} isFullScreen={isFullScreen} />}
      {item.type === "Image" && <DSPlayerImage item={item} isFullScreen={isFullScreen} />}
      {item.type === "Audio" && <DSPlayerAudio item={item} onAudioEnded={onAudioEnded} isFullScreen={isFullScreen} />}
      {item.type === "Split" && <DSPlayerSplit item={item} isFullScreen={isFullScreen} />}
      {item.type === "Link" && <DSPlayerLink item={item} isFullScreen={isFullScreen} />}
      {item.type === "Doc" && <DSPlayerDoc item={item} isFullScreen={isFullScreen} />}
      {item.type === "DynamicFromTemplate" && <DSPlayerDynamicFromTemplate item={item} isFullScreen={isFullScreen} />}
    </>
  );
};
